import { Length } from "class-validator";

class Address {
    @Length(1, 50)
    cityName: string = '';

    streetName: string = '';

    @Length(1, 50)
    streetNumber: string = '';
    
    apartmentNumber: string = '';

    @Length(5, 6)
    postalCode: string = '';
  }

  export default Address;